"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    '@keyframes loadingLabel': {
      '0%': {
        opacity: 0.3
      },
      '50%': {
        opacity: 1
      },
      '100%': {
        opacity: 0.3
      }
    },
    loadingLabel: {
      background: palette.divider,
      borderRadius: 3,
      pointerEvents: 'none',
      userSelect: 'none',
      opacity: 0.5,
      animationName: '$loadingLabel',
      animationDuration: '1s',
      animationIterationCount: 'infinite',
      animationTimingFunction: 'ease-out'
    }
  };
});

var LoadingLabel = function LoadingLabel(_ref2) {
  var className = _ref2.className,
      props = (0, _objectWithoutProperties2["default"])(_ref2, ["className"]);
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.loadingLabel, className),
    width: 66,
    height: 18
  }, props));
};

var _default = /*#__PURE__*/(0, _react.memo)(LoadingLabel);

exports["default"] = _default;